const subCategoriesKeys = {
  module: ['SubCategories'] as const,
  list: () => [...subCategoriesKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...subCategoriesKeys.list(), filters] as const,
  details: (id: string) =>
    [...subCategoriesKeys.module, 'details', id] as const,
};

export default subCategoriesKeys;
